import styled from "styled-components";

export const StyledPricingList = styled.div`
    width: 100%;
    padding: 20px;
    @media (min-width: 576px) {
        padding: 50px;
    }
    .logo-wrap {
        text-align: center;
        margin-bottom: 30px;
        @media (min-width: 576px) {
            margin-bottom: 40px;
        }
        .logo {
            width: 150px;
            height: auto;
            @media (min-width: 576px) {
                width: 250px;
            }
        }
    }
    .title {
        color: var(--text-color);
        font-size: 28px;
        line-height: 32px;
        font-weight: 400;
        text-align: center;
        margin-bottom: 30px;
        @media (min-width: 576px) {
            margin-bottom: 40px;
            font-size: 40px;
            line-height: 44px;
        }
    }
    .btn {
        margin: 0 auto 32px 0;
        display: flex;
        align-items: center;
        min-width: 87px;
        padding: 9px 5px;
        &:hover {
            background: ${({theme}) => theme?.light?.primary};
            color: var(--white);
        }
    }
`;
